<template>
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="34"
      height="34"
      rx="6"
      fill="#FFD9C3"
    />
    <g clip-path="url(#clip0_3491_2704)">
      <path
        d="M17 9.66663V24.3333"
        stroke="#FF8A71"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.3333 12.3334H15.3333C14.7145 12.3334 14.121 12.5792 13.6834 13.0168C13.2458 13.4544 13 14.0479 13 14.6667C13 15.2855 13.2458 15.879 13.6834 16.3166C14.121 16.7542 14.7145 17 15.3333 17H18.6667C19.2855 17 19.879 17.2459 20.3166 17.6835C20.7542 18.121 21 18.7145 21 19.3334C21 19.9522 20.7542 20.5457 20.3166 20.9833C19.879 21.4209 19.2855 21.6667 18.6667 21.6667H13"
        stroke="#FF8A71"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3491_2704">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(9 9)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
